module.exports = __webpack_public_path__ + "static/media/edit-icon.b981b59d.svg";